import React from "react";

const DeleteIcon = ({
  height = 11,
  width = 10,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 10 11"
    fill="none"
    className={className}
  >
    <path
      d="M10 1.50714L8.99286 0.5L5 4.49286L1.00714 0.5L0 1.50714L3.99286 5.5L0 9.49286L1.00714 10.5L5 6.50714L8.99286 10.5L10 9.49286L6.00714 5.5L10 1.50714Z"
      fill="white"
    />
    <mask
      id="mask0_2119_6084"
    //   style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="10"
      height="11"
    >
      <path
        d="M10 1.50714L8.99286 0.5L5 4.49286L1.00714 0.5L0 1.50714L3.99286 5.5L0 9.49286L1.00714 10.5L5 6.50714L8.99286 10.5L10 9.49286L6.00714 5.5L10 1.50714Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2119_6084)">
      <rect
        x="-3.57153"
        y="-3.07143"
        width="17.1429"
        height="17.1429"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default DeleteIcon;
